// extracted by mini-css-extract-plugin
export default {"cls1":"ReRlsHJ4RrmdRNi5_MTC","cls2":"ask8hTirBC9AJsB9Qtok ReRlsHJ4RrmdRNi5_MTC"};